/* Shared layout primitives for pages. Component-specific rules stay local. */

.stack {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.stackTight {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.row {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  flex-wrap: wrap;
}

.grid {
  display: grid;
  gap: var(--space-4);
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
}

.gridWide {
  display: grid;
  gap: var(--space-4);
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
}

.split {
  display: grid;
  gap: var(--space-4);
  grid-template-columns: minmax(0, 1.6fr) minmax(0, 1fr);
  align-items: start;
}

@media (max-width: 900px) {
  .split {
    grid-template-columns: minmax(0, 1fr);
  }
}

.sectionHeader {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-3);
}

.sectionTitle {
  font-size: var(--text-lg);
  font-weight: 650;
}

.sectionHint {
  font-size: var(--text-sm);
  color: var(--text-muted);
}
